export default __webpack_public_path__ + "static/media/subscription_premium.1b0cc95e.png";